import React from "react";
import { jwtDecode } from "jwt-decode";
import { isFieldVendorLevel } from "../utils/homePath";
import AccessGuard from "./AccessGuard";

/**
 * RequireNotFieldVendor
 * Bloquea SOLO al rol nuevo (vendedor de campo, `isFieldVendorLevel`).
 * Deja pasar a todos los demás exactamente como hoy.
 *
 * Para rutas cuyo `sectionId` tiene override real de producción en 0
 * (`dashboard`, `televenta`, `nuevo_cliente`): envolverlas en `RequireAccess`
 * bloquearía TAMBIÉN a los niveles 1-3, que hoy entran libremente (rompería a
 * Trini). Este guard NO usa `canAccess`/`sectionId` — decide por el nivel
 * crudo del JWT, igual que `homePathForLevel`, porque la configuración de
 * secciones no describe la realidad de estas 3 rutas.
 *
 * `isFieldVendorLevel` usa un rango ACOTADO, no "mayor o igual": el fallback
 * `?? 99` de un JWT sin nivel legible NO debe caer en el rol nuevo (fail-closed,
 * ver `homePath.js`). Antes de acotar el rango, un token con nivel ilegible
 * quedaba bloqueado aquí igual que un vendedor de campo real (Hallazgo 1,
 * tarea 7) — el fallback debe seguir sin acceso a nada, pero por el motivo de
 * siempre (fail-closed genérico), no por confundirse con este rol concreto.
 *
 * Sin token/nivel ilegible → fail-open (no bloquea), igual que el resto de
 * guards de nivel de esta app (`RequireAccess`, `currentHomePath`).
 *
 * Comparte con `RequireAccess` el aviso "sin acceso" y la protección
 * anti-bucle vía `AccessGuard` en vez de duplicarlos.
 */
const RequireNotFieldVendor = ({ children }) => {
  let level = null;
  try {
    const token = localStorage.getItem("token");
    if (token) {
      const payload = jwtDecode(token);
      level = Number(
        payload?.level ?? payload?.dept_level ?? payload?.admin_level ?? 99
      );
    }
  } catch (_) {
    level = null;
  }

  const denied = isFieldVendorLevel(level);

  return (
    <AccessGuard loading={false} denied={denied}>
      {children}
    </AccessGuard>
  );
};

export default RequireNotFieldVendor;
